import { MaxSizeValidator } from '@angular-material-components/file-input';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";


@Component({
  selector: 'app-dialog-asociar-informe',
  templateUrl: './dialog-asociar-informe.component.html',
  styleUrls: ['./dialog-asociar-informe.component.scss']
})
export class DialogAsociarInformeComponent implements OnInit {

  files;
  maxSize= 2; //Maximo 2MB

  formulario: FormControl;
  constructor(
      public dialogRef: MatDialogRef<DialogAsociarInformeComponent>,  
      @Inject(MAT_DIALOG_DATA) public data: any,) { 
        this.formulario = new FormControl(this.files, [Validators.required, MaxSizeValidator((this.maxSize * 1024)*1024)]);
  }


  ngOnInit(): void {
    this.formulario.valueChanges.subscribe((files: any) => {
        this.files = files;
    })
  }

  get informe() {
    return this.formulario.get("informe");
  }
}
